module.exports = __webpack_public_path__ + "images/stickers/pete-shipped@2x.ebfcc0cc9adce809dc74.png";